import { Component, OnInit, OnDestroy } from '@angular/core';
import {MenuBarComponent} from "../../shared/components/menu-bar/menu-bar.component";
import {RouterOutlet} from "@angular/router";
import {TopBarComponent} from '../../shared/components/top-bar/top-bar.component';
import {BusinessDetailsBarComponent} from '../../shared/components/business-details-bar/business-details-bar.component';
import {LoaderComponent} from '../../shared/components/loader/loader.component';
import {NgIf} from '@angular/common';
import {LoaderService} from '../../core/services/loader/loader.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-home-layout',
  standalone: true,
  imports: [
    MenuBarComponent,
    RouterOutlet,
    TopBarComponent,
    BusinessDetailsBarComponent,
    LoaderComponent,
    NgIf
  ],
  templateUrl: './home-layout.component.html',
  styleUrl: './home-layout.component.css'
})
export class HomeLayoutComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();
  isLoading = false;
  private destroy$ = new Subject<void>();

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    // Subscribe to loader state with proper cleanup
    this.loaderService.loaderState$
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.isLoading = state;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
